import Head from 'next/head';

const SubscriptionSuccess = () => {
  return (
    <div className='tw-w-[90%] tw-mx-auto lg:tw-w-[83%] 2xl:tw-w-[90rem] tw-h-screen tw-grid tw-place-content-center'>
      <Head>
        <link
          rel='canonical'
          href='https://www.24hrdoc.com/subscription-success'
        />
        <meta name='robots' content='noindex, nofollow' />
      </Head>
      <p className='lg:tw-text-center tw-font-medium tw-text-2xl lg:tw-text-4xl'>
        Thank you for subscribing to{' '}
        <span className='tw-font-semibold gradientText'>24hrDoc</span>
      </p>
      <p className=' tw-text-xl lg:tw-text-center'>
        We&apos;re honored to support your health journey. Reach out whenever
        you&apos;re ready—no waiting rooms, just care.
      </p>
    </div>
  );
};

export default SubscriptionSuccess;
